import { SFPalette } from '@/lib/color';
import { fontWeight, notoSansKr } from '@/theme';
import styled from '@emotion/styled';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

export const SFToastContainer = styled(ToastContainer)`
  .Toastify__toast {
    font-size: 16px;
    border-radius: 50px;
    padding: 8px 16px;
    color: #fff;
    background: ${SFPalette.grey4};
    font-family: ${notoSansKr.style.fontFamily};
    font-size: 0.875rem;
    font-weight: ${fontWeight.Bold};
    min-height: auto;
  }
  .Toastify__toast-container {
    padding-right: 44px;
    padding-left: 44px;
  }
  .Toastify__toast-body {
    padding: 0;
    margin: 0;
  }

  .Toastify__toast-icon {
    /* width: 16px;
    height: 16px; */
  }

  .Toastify__toast--info {
    /* background: rgba(107, 115, 135, 0.8); */
  }

  .Toastify__toast--success {
    /* background: rgba(48, 173, 120, 0.8); */
  }

  .Toastify__toast--error {
    /* background: rgba(224, 72, 82, 0.8); */
  }
`;
